/**
 * Blog Stories Block JavaScript
 */

(function () {
  "use strict";

  // Initialize block functionality
  function initBlogStories() {
    const blocks = document.querySelectorAll(".blog-stories");

    blocks.forEach((block) => {
      const postsContainer = block.querySelector(".posts");
      const loadMoreButton = block.querySelector(".load-more-button");
      const loadMoreWrapper = block.querySelector(".load-more-wrapper");

      if (!postsContainer) {
        return;
      }

      // Track current state
      let currentOffset = 0;
      const postsPerPage =
        parseInt(postsContainer.getAttribute("data-posts-per-page")) || 3;
      const category =
        parseInt(postsContainer.getAttribute("data-category")) || 1;

      // Store initial offset - set to number of posts already displayed
      const initialPostsCount = postsContainer.querySelectorAll(".news_post").length;
      postsContainer.setAttribute("data-current-offset", initialPostsCount.toString());

      // Handle Load More button click
      if (loadMoreButton) {
        loadMoreButton.addEventListener("click", function () {
          // Get current offset (how many posts have been displayed)
          currentOffset = parseInt(
            postsContainer.getAttribute("data-current-offset") || "0"
          );
          // Use current offset for the request (offset will be updated in success callback)
          loadMoreBlogStories(
            block,
            postsContainer,
            loadMoreWrapper,
            category,
            currentOffset,
            postsPerPage
          );
        });
      }
    });
  }

  /**
   * Reinitialize lazy loading for newly loaded content
   */
  function reinitLazyLoading(container) {
    // Try lozad - observe all new lazy elements
    if (typeof lozad !== "undefined") {
      // Find all lazy elements in the container that haven't been loaded yet
      const allLazyElements = container.querySelectorAll(".lazy");

      if (allLazyElements.length > 0) {
        // If we have an existing observer, use it
        if (window.lozadObserver) {
          // Observe all elements in container (lozad handles duplicates)
          allLazyElements.forEach((el) => {
            if (!el.hasAttribute("data-loaded")) {
              window.lozadObserver.observe(el);
            }
          });
        } else {
          // Create new observer and store it globally
          window.lozadObserver = lozad(".lazy", {
            loaded: function (el) {
              el.classList.add("loaded");
              el.setAttribute("data-loaded", "true");
              // Force layout recalculation after image loads
              void el.offsetHeight;
            },
          });
          // Observe all elements
          window.lozadObserver.observe();
        }
      }
    }

    // Try LazyLoad (common library) - use update method
    if (typeof LazyLoad !== "undefined") {
      if (window.lazyLoadInstance) {
        // Update existing instance - this will scan for new elements
        window.lazyLoadInstance.update();
      } else {
        // Create new instance
        window.lazyLoadInstance = new LazyLoad({
          elements_selector: ".lazy",
        });
        window.lazyLoadInstance.update();
      }
    }

    // Try WP Rocket lazy loading (dispatches custom event)
    if (typeof window.dispatchEvent !== "undefined") {
      const event = new CustomEvent("lazyload-update", {
        detail: { container: container },
      });
      window.dispatchEvent(event);
    }

    // Force browser to recalculate layout after a short delay
    setTimeout(() => {
      // Trigger scroll event to help lazy loading libraries detect new content
      window.dispatchEvent(new Event("scroll"));

      // Force layout recalculation by reading offsetHeight
      void container.offsetHeight;

      // Trigger resize event to help browsers recalculate page height
      window.dispatchEvent(new Event("resize"));
    }, 100);
  }

  /**
   * Load more blog stories via AJAX
   */
  function loadMoreBlogStories(
    block,
    container,
    loadMoreWrapper,
    category,
    offset,
    postsPerPage
  ) {
    // Show loading state
    const loadMoreButton = block.querySelector(".load-more-button");
    if (loadMoreButton) {
      loadMoreButton.disabled = true;
      loadMoreButton.textContent = "Loading...";
    }

    // Make AJAX request
    const formData = new FormData();
    formData.append("action", "blog_stories_load_more");
    formData.append("nonce", blogStoriesAjax.nonce);
    formData.append("category", category);
    formData.append("offset", offset);
    formData.append("posts_per_page", postsPerPage);

    fetch(blogStoriesAjax.ajaxurl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // Append new posts
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = data.data.html;
          const newPosts = tempDiv.querySelectorAll(".news_post");

          newPosts.forEach((post) => {
            container.appendChild(post);
          });

          // Update offset after successfully loading posts
          const currentOffset = parseInt(container.getAttribute("data-current-offset") || "0");
          container.setAttribute("data-current-offset", (currentOffset + newPosts.length).toString());

          // Reinitialize lazy loading for newly appended content
          reinitLazyLoading(container);

          // Force page height recalculation after images have time to load
          setTimeout(() => {
            // Force layout recalculation by reading dimensions
            void container.offsetHeight;
            void document.body.offsetHeight;
            void document.documentElement.offsetHeight;

            // Trigger resize event to help browsers recalculate
            window.dispatchEvent(new Event("resize"));
          }, 500);

          // Hide button if no more posts
          if (loadMoreWrapper && !data.data.has_more) {
            loadMoreWrapper.style.display = "none";
          }
        } else {
          console.error("Error loading blog stories:", data.data.message);
        }
      })
      .catch((error) => {
        console.error("AJAX error:", error);
      })
      .finally(() => {
        // Remove loading state
        const loadMoreButton = block.querySelector(".load-more-button");
        if (loadMoreButton) {
          loadMoreButton.disabled = false;
          loadMoreButton.textContent = "Load more";
        }
      });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBlogStories);
  } else {
    initBlogStories();
  }
})();
